const updatedInstructor = (instructor, testimonials, courses) => {
    try {
        const courseByInstructor = (courses || [])?.filter((item) => item?.instructorId === instructor?.id)?.length;
        const instructoreRating = (testimonials || [])?.filter((item) => item?.instructorId === instructor?.id);
        let totalRating = 0;
        let validRatingCount = 0;
        (instructoreRating || [])?.forEach(item => {
            const ratings = Number(item.rating);
            if (typeof ratings === 'number') {
                totalRating += ratings;
                validRatingCount++;
            }
        });

        const averageRating = validRatingCount > 0 ? totalRating / validRatingCount : 0;

        return {
            ...instructor,
            features: [
                {
                    "title": "COURSE AUTHOR",
                    "numbers": `${courseByInstructor}`
                },
                {
                    "title": "TOTAL RATING",
                    "numbers": `${instructoreRating?.length || 0}`
                },
                {
                    "title": "AVE. RATING",
                    "numbers": `${averageRating}`
                }
            ]
        };
    } catch (error) {
        console.log("Error while changing instructor features => ", error);
    }
}

export {
    updatedInstructor
};
